export default __webpack_public_path__ + "static/media/email.99915310.svg";